// extracted by mini-css-extract-plugin
export default {"wrapper":"qD-z","viewport":"rD-z","container":"sD-z","slide":"tD-z"};